import { type PopoverOrigin } from '@mui/material';
import { SignOutIcon } from '@phosphor-icons/react/dist/ssr/SignOut';
import { vars } from '@tgtg/kit';
import { FormattedMessage } from 'react-intl';

import msg from './messages';
import NavPopover, { type NavPopoverItem } from './NavPopover';

const DEFAULT_ANCHOR_ORIGIN: PopoverOrigin = { vertical: -12, horizontal: 'center' };
const DEFAULT_TRANSFORM_ORIGIN: PopoverOrigin = { vertical: 'bottom', horizontal: 'center' };

const SIGN_OUT_ITEMS: NavPopoverItem[] = [
  {
    id: 'sign-out',
    to: '/logout',
    label: <FormattedMessage {...msg.signOut} />,
    icon: <SignOutIcon style={{ width: vars.size.size300, height: vars.size.size300 }} />,
  },
];

type UserMenuPopoverProps = {
  anchorEl: HTMLElement | null;
  isPopoverOpen: boolean;
  onPopoverClose: VoidFunction;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
};

const UserMenuPopover = ({
  anchorEl,
  isPopoverOpen,
  onPopoverClose,
  anchorOrigin = DEFAULT_ANCHOR_ORIGIN,
  transformOrigin = DEFAULT_TRANSFORM_ORIGIN,
}: UserMenuPopoverProps) => {
  return (
    <NavPopover
      items={SIGN_OUT_ITEMS}
      anchorEl={anchorEl}
      isOpen={isPopoverOpen}
      onClose={onPopoverClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
    />
  );
};

export default UserMenuPopover;
